import { createTheme } from '@mui/material';

let theme = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 1130, lg: 1240, xl: 1940 } },
})
theme = createTheme( theme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius:"0px !important",
          minHeight:"55px",
          fontFamily: 'Questrial !important',
          fontSize:"16px",
          textTransform:"unset",
          [theme.breakpoints.up('sm')]: {
            minHeight:"60px",
            fontSize:"17px",
          },
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.8)",
          },
        },
      },
    },
    MuiSlider : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
        markLabel : {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiButtonBase : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          borderRadius:"0px !important",
          background:"white",
          height:'50px',
          "fieldset" : {
            border:"1px solid black",
          },
          [theme.breakpoints.up('sm')]: {
            height:'60px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          color:"rgba(10, 10, 11, 0.5) !important",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiPaper : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          borderRadius:0,
        },
      },
    },
    MuiMenuItem : {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
          paddingLeft:"24px",
          paddingRight:"24px",
        },
      },
    },
    MuiFormHelperText:{
      styleOverrides: {
        root: {
          fontFamily: 'Questrial !important',
        },
      },
    },
  },
  palette: {
    background: {
      default: '#ffffff',
      paper: '#ffffff',
      grey: '#FAF8F6',
      /* Redesign Valentin 2026 : SECONDE bande chaude OBSERVED (Etape 1),
         ex. groupes-chapitres de la Fin de module. `grey` (#FAF8F6) reste la
         premiere bande. Jeton pose ici, consomme par les lots de formats. */
      grey2: '#F2F0EF',
    },
    primary: {
      contrastText: '#ffffff',
      main: '#000000'
    },
    /* Redesign Valentin 2026 : couleur d'ACCENT OBSERVED (#478DFF), bordure et
       libelle du tag/pill au-dessus du contenu. Jeton central : les formats la
       consommeront a la place du hex en dur, lot par lot. */
    accent: {
      main: '#478DFF',
    },
    /* Redesign Valentin 2026 : palette de FEEDBACK / JAUGES OBSERVED (Etape 1
       §2). Aujourd'hui codee en dur dans FormatQuizz / FormatDiag ; tokenisee
       ici pour etre reprise lors des lots concernes, SANS recabler ces formats
       maintenant (hors perimetre I1). `wrong` = orange « bonne reponse oubliee »
       (resolu par le code en Etape 2). */
    feedback: {
      correct: '#53D769',
      /* ⚠️ Reconcilie le 22/09 sur la valeur MESUREE : les nodes 3:362460
         (Desktop) et 13:695 (Mobile) donnent #FED030. Le « jeton Figma 2026 »
         qu'invoquait le commentaire precedent pour justifier #FED64A n'a ete
         retrouve nulle part dans le fichier. Un jeton se decide une fois. */
      warn: '#FED030',
      wrong: '#E26438',
    },
    text: {
      primary: '#565656',
      secondary: '#0A0A0B',
      black: '#000000',
      /* ⚠️ L'ENCRE DU REDESIGN (22/09). Plusieurs nodes donnent #1A1925 la ou
         le code pose du noir pur : titre de planche, nom de competence, score.
         Ce n'est pas un noir absolu mais une encre legerement bleutee. Jeton
         introduit ici pour se decider UNE FOIS plutot que format par format. */
      ink: '#1A1925',
      blackTitle:"#23272E",
      /* ⚠️ Relu dans Figma le 21/09/2026 : la consigne vaut rgba(0,0,0,0.7)
         aux TROIS paliers (noeuds 3:302258, 3:282077, 3:282136). La base etait
         (10,10,11) et l'alpha 0,75 : le texte secondaire etait 5 points trop
         dense. Tous les consommateurs connus de ce jeton sont des consignes. */
      subTitle:"rgba(0, 0, 0, 0.7)",
    }
  },
  shadows: [
    'none',
    '0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
  ],
  typography: {
    fontFamily: 'Questrial',
    allVariants: {
      fontFamily: 'Questrial',
    },
    h1: {
      fontSize: 35,
    },
    h2: {
      fontSize: "26px",
      [theme.breakpoints.up('sm')]: {
        fontSize: '46px',
      },
    },
    h3: {
      fontSize: 24,
    },
    h4: {
      fontSize: 20,
    },
    h5: {
      fontSize: 16,
    },
    h6: {
      fontSize: 14,
    },
  }
});

export default theme;
